<template>
  <div class="crunchieMain">
    <Designer class="designer1" form="TSManifest.json"/>
  </div>
</template>

<script>
  import Designer from '@/components/reportDesigner/Designer.vue';
  /* eslint-disable */
  
  
  export default {
    name: 'crunchie',
    components: {
        Designer
    },
    props: {
      
    },
    data() {
      return {
        
      }
    },
    mounted() {

    },
    beforeDestroy() {
      
    },
    methods: {
      
    },
    watch: {
      // template: { deep: true, handler(h) { /*code*/ } },
    },
  };
</script>

<style scoped>

  .crunchieMain {
    width: 100%;
    height: 100%;
    padding: 10px 50px;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    background-color: #EEEF;
    border: solid 1px #000F;
  }

  .designer1 {
    width: 800px;
    height: 100%;
  }

</style>